import { styled } from '@mui/material';
import React from 'react';
import {
  DasEndpointType,
  FeatureListType,
  OtherFeatureType,
  SSSSFeatureType,
} from '../../../types/Device';
import { ProjectFeature } from '../../../types/Project';
import BasicContent from './BasicContent';
import SSSSContent from './SSSSContent';
import { MainFeature } from '../../../types';

const Container = styled('div')`
  padding: 0 36px;

  & svg {
    display: block;
  }

  & .title {
    color: ${({ theme }) => theme.color.secondary.$60};
  }

  & ul {
    list-style-type: none;
    padding: 0;
    margin: 10px 0;

    & .switch-container {
      display: flex;
      align-items: center;
      gap: 10px;
      & > div:nth-of-type(1) {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 10px;
      }
      & > div:nth-of-type(2) {
        cursor: pointer;
        &.disabled {
          pointer-events: none;
          color: ${({ theme }) => theme.color.secondary.$40};
        }
      }
    }

    & li {
      margin: 10px 0;
      & > .metadata-setting {
        display: flex;
        align-items: center;
        gap: 10px;
        padding-left: 50px;
      }
    }
  }

  & hr {
    border-top: 1px solid ${({ theme }) => theme.color.secondary.$40};
    margin: 10px 0;
  }
`;

interface FeatureProps {
  mainFeatureType: MainFeature;
  projectFeature:
    | {
        [type: string]: ProjectFeature;
      }
    | undefined;
  handleOnChange: (
    type:
      | DasEndpointType
      | FeatureListType
      | OtherFeatureType
      | SSSSFeatureType,
    checked: boolean,
  ) => Promise<void>;
  handleOnChangeMetadata: (
    type:
      | DasEndpointType
      | FeatureListType
      | OtherFeatureType
      | SSSSFeatureType,
    key: string,
    value: any,
  ) => Promise<void>;
  setSelectedType: React.Dispatch<
    React.SetStateAction<
      DasEndpointType | FeatureListType | OtherFeatureType | SSSSFeatureType
    >
  >;
  setIsOpenSettingDialog: (isOpen: boolean) => void;
}

const Feature: React.FC<FeatureProps> = ({
  mainFeatureType,
  projectFeature,
  handleOnChange,
  handleOnChangeMetadata,
  setSelectedType,
  setIsOpenSettingDialog,
}) => {
  return (
    <Container>
      {mainFeatureType === 'four_s' ? (
        <SSSSContent
          projectFeature={projectFeature}
          handleOnChange={handleOnChange}
          handleOnChangeMetadata={handleOnChangeMetadata}
          setSelectedType={setSelectedType}
          setIsOpenSettingDialog={setIsOpenSettingDialog}
        />
      ) : (
        <BasicContent
          projectFeature={projectFeature}
          handleOnChange={handleOnChange}
          setSelectedType={setSelectedType}
          setIsOpenSettingDialog={setIsOpenSettingDialog}
          mainFeatureType={mainFeatureType}
        />
      )}
    </Container>
  );
};

export default Feature;
